module.exports = __webpack_public_path__ + "img/clicker.5176d4f3.gif";